import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { ListingPickerStoreContext } from './contexts/StoreContext'
import { createListingPickerStore } from './store'

export const ListingPickerProvider = ({ children }: PropsWithChildren) => {
  const store = useCreation(() => createListingPickerStore(), [])
  return (
    <ListingPickerStoreContext value={store}>
      {children}
    </ListingPickerStoreContext>
  )
}
